import { createAction } from '@reduxjs/toolkit';

import { createAsyncActions, createActions } from '@modules/helpers';

import { UniqueElementDataType } from './types';

const actions = createActions('operationBlock', {
  setLeft: name => createAction<UniqueElementDataType>(name),

  setRight: name => createAction<UniqueElementDataType>(name),
});

export const asyncActions = createAsyncActions('operationBlock', {});

export default { ...actions, ...asyncActions };
